import { CloseRounded } from "@mui/icons-material";
import { AnimatePresence, motion } from "framer-motion";
import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { useGetAddressesQuery, useGetCartItemsQuery } from "../../../redux/APIs/cartApi";
import AddressCards from "../../AddressCards";
import AddNewAdrsForm from "../Checkout/AddNewAdrsForm";
import CheckoutStepper from "../Checkout/subComponents/CheckoutStepper";
import PriceBreakup from "../Checkout/subComponents/PriceBreakup";
import "./AllAddresses.css";

function AllAddresses() {
  const { data: cartItems } = useGetCartItemsQuery();
  console.log('cartItems', cartItems);
  const {data: addresses} = useGetAddressesQuery();
  console.log('addresses', addresses);

  const [showPopup, setShowPopup] = useState('');

  return (
    <Fragment>
      <div className="pt-2 bg-slate-100 h-fit sm:mt-[60px] max-sm:mt-[120px] w-full">
        <div className="md:max-w-[1100px] max-sm:max-w-[100dvw] min-h-[100dvh] mx-auto ">
          <CheckoutStepper />
          <div className="flex max-md:flex-col gap-2 h-full max-sm:px-0 max-xl:px-2">
            {/* left sec for lg screen */}
            <div className="w-full h-full bg-white min-h-[600px]">
              <div className="md:flex-1 flex justify-between p-3">
                <p className="text-lg font-[600]">Your Addresses</p>
                {addresses?.addressCount > 0 && (
                  <button
                    className="px-2 h-8 rounded-lg text-xs font-[500] border-pink-600 border-[1px] hover:bg-pink-100 hover:scale-105 transition-all"
                    onClick={() => setShowPopup('addAddress')}
                  >
                    Add New +
                  </button>
                )}
              </div>
              {/* address cards */}
              <div className="px-3">
                {addresses?.addressCount === 0 ? (
                  <div className="h-full w-full text-center pt-20">
                    <p>No saved address found!</p>
                    <button
                      className="px-3 py-1.5 rounded-full border-pink-600 border-[1px] text-sm font-[600] hover:bg-pink-100 hover:scale-105 transition-all"
                      onClick={() => setShowPopup('addAddress')}
                    >
                      Add New +
                    </button>
                  </div>
                ) : (
                  <div></div>
                )}
                {addresses?.allAddresses?.map((address) => (
                  <AddressCards address={address} />
                ))}
              </div>
            </div>
            <div className="max-md:w-full max-lg:w-72 max-lg:text-[0.9rem]">
              <PriceBreakup priceDetails={cartItems?.priceDetails} />
              <div
                className="max-sm:flex max-sm:justify-end max-md:sticky max-md:bottom-0 max-md:w-full bg-white md:mt-2 md:rounded-xl max-md:bg-white max-md:p-2 md:p-4 max-md:justify-end max-sm:bottom-[45px]"
                style={{ boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)' }}
              >
                <Link
                  to="/checkout/payment"
                  className="flex justify-center items-center no-underline w-52 h-10 md:h-12 md:w-full rounded-full bg-gradient-to-r from-red-500 to-pink-600 bg-red-700 text-white hover:scale-105 transition-all cursor-pointer"
                >
                  Proceed to Payment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AnimatePresence>
        {showPopup === 'addAddress' && (
          <motion.div
            className="fixed inset-0 z-2 backdrop-blur-[0.5rem] bg-opacity-50 flex justify-center pt-10 overflow-auto hide-scrollbar bg-transparent"
            initial={{
              opacity: 0.5,
              scale: 0,
              // x: popupPosition.x - window.innerWidth / 2.2,
              // y: popupPosition.y - window.innerHeight / 2.1,
            }}
            animate={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: 0,
            }}
            exit={{
              opacity: 0.5,
              scale: 0,
              // x: popupPosition.x - window.innerWidth / 2.2,
              // y: popupPosition.y - window.innerHeight / 2.1,
            }}
            transition={{
              type: 'spring',
              stiffness: 120,
              damping: 20,
              duration: 0.5,
              ease: 'easeInOut',
            }}
          >
            <div className="lg:relative absolute bottom-[35px] max-sm:bottom-0 max-md:w-[100dvw] max-sm:w-[100dvw] max-sm:h-[80dvh] w-[900px] sm:h-[550px] h-[450px] flex gap-2 lg:mt-24 mb-0 max-sm:mt-[20px] rounded-[20px] md:p-2 overflow-hidden">
              <div className="relative w-full h-full max-md:w-[100dvw] max-md:flex max-md:justify-center lg:flex lg:gap-2 bg-transparent rounded-[15px] lg:p-3">
                <button
                  className="absolute -top-0 right-0 max-sm:-top-1 max-sm:shadow-sm max-sm:left-1/2 max-sm:-translate-x-1/2 max-sm:w-9 max-sm:h-9 w-10 h-10 bg-white rounded-full flex items-center justify-center"
                  onClick={() => setShowPopup('')}
                >
                  <CloseRounded style={{ fontSize: '1.2rem' }} />
                </button>

                <div className="p-2">
                  <AddNewAdrsForm />
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      {/* <AddNewAdrsForm /> */}
    </Fragment>
  );
}

export default AllAddresses;
